// src/components/TechnologySection.tsx
import { Row, Col, Card, Typography, Image } from 'antd';
import { ExperimentOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import RadarPointImg from '../assets/radar-point.png';
import FD1Img from '../assets/fd1.png';

const { Title, Paragraph } = Typography;

const TechnologySection = () => {
  const { t } = useTranslation();

  return (
    <section className="technology-section">
      <div className="section-container">
        <div className="section-header">
          <ExperimentOutlined className="section-icon" />
          <Title level={2}>{t('technology.title')}</Title>
          <Paragraph className="section-subtitle">
            {t('technology.subtitle')}
          </Paragraph>
        </div>

        <Row gutter={[48, 48]} align="middle">
          <Col xs={24} lg={12}>
            <Card className="tech-card" bordered={false}>
              <Title level={4}>{t('technology.items.fallDetection.title')}</Title>
              <Paragraph>
                {t('technology.items.fallDetection.description')}
              </Paragraph>
              <div className="tech-image">
                <Image
                  src={FD1Img}
                  alt={t('technology.items.fallDetection.altText')}
                  preview={false}
                  fallback="/placeholder-tech.jpg"
                />
              </div>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card className="tech-card" bordered={false}>
              <Title level={4}>{t('technology.items.humanRecognition.title')}</Title>
              <Paragraph>
                {t('technology.items.humanRecognition.description')}
              </Paragraph>
              <div className="tech-image">
                <Image
                  src={RadarPointImg}
                  alt={t('technology.items.humanRecognition.altText')}
                  preview={false}
                  fallback="/placeholder-tech.jpg"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default TechnologySection;
